<template>
  <div class="wrapp-search listing-search" :class="{ 'open-search': searchReady }">
    <div class="search-backdrop" :class="{ 'show-backdrop': canShowBackdrop }" @click.prevent="resetSearch"></div>
    <div class="background-backdrop"></div>
    <div class="wrapp-form-search">
      <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated animate__fadeOut animate__faster">
        <!-- 20.05.21 request remove qrcode untill service is set -->
        <!-- was -> v-show="!searchReady" -->
        <div class="wrapp-icon" v-show="!searchReady" @click.prevent="openScanReader">
          <svg class="o-icon"><use xlink:href="#qr-code"></use></svg>
        </div>
      </transition>
      <b-form-group class="search-in-nav">
        <base-input
          name="search"
          type="text"
          classInput="input-search rounded"
          v-model="navSearch"
          :placeholder="$t('search.products-placeholder')"
          @input="searchProduct"
        >
        </base-input>
      </b-form-group>
      <div class="after-input">
        <button class="btn btn-icon btn-none" v-if="searchReady" @click.prevent="resetSearch">
          <svg class="o-icon stroke-black"><use xlink:href="#close-small"></use></svg>
        </button>
        <button class="btn btn-icon btn-none" v-else @click.prevent="initSearch">
          <svg class="o-icon"><use xlink:href="#search"></use></svg>
        </button>
      </div>
    </div>
    <products-filtered :searchResponse="searchResponse" :inputText="navSearch" v-if="canShowProducts">
      <template #footer>
        <absolute-loader :showLoader="showLoader"></absolute-loader>
      </template>
    </products-filtered>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import BaseInput from 'theme/components/Form/BaseInput'
import ProductsFiltered from 'theme/components/Search/manageCriteria/Products'
import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'

export default {
  name: 'SearchFilter',
  data () {
    return {
      canShowBackdrop: false,
      canShowProducts: false,
      showLoader: false,
      searchResponse: null,
      searchReady: false,
      navSearch: '',
      readerSize: {
        width: 640,
        height: 480
      },
      detecteds: []
    }
  },
  methods: {
    searchProduct: debounce(function () {
      const _this = this
      if (this.navSearch.length > 0) {
        this.searchClicked(true)
        this.showLoader = true
        this.$store.dispatch('search/searchProduct', { inputText: _this.navSearch })
          .then((res) => {
            _this.searchResponse = res
          })
          .finally(() => {
            _this.showLoader = false
          })
      } else {
        this.resetSearch()
      }
    }, 500),
    resetSearch () {
      this.navSearch = ''
      this.searchResponse = null
      this.searchClicked(false)
    },
    searchClicked (boolVal) {
      $('html').toggleClass('overflow-hidden', boolVal)
      if (boolVal) {
        this.openResultPanel()
      } else {
        this.closeResultPanel()
      }
    },
    initSearch () {
      const _this = this
      $('html, body').animate({
        scrollTop: 0
      }, 300, function () {
        _this.searchClicked(true)
      })
      $('.input-search').focus()
    },
    openResultPanel () {
      const _this = this
      this.canShowBackdrop = true
      this.searchReady = true
      $('.wrapp-ctas .wrapp-current-store').fadeOut()
      $('.wrapp-breadcrumb').fadeOut()
      $('.listing-search').animate({ width: $('.wrapp-ctas').outerWidth() }, 300, function () {
        $('.background-backdrop').animate({ height: $('.wrapp-search').innerHeight() - 84 }, 300)
        setTimeout(() => {
          _this.canShowProducts = true
        }, 800)
      })
    },
    closeResultPanel () {
      const _this = this
      this.canShowProducts = false
      $('.background-backdrop').animate({ height: $('.wrapp-form-search').height() }, 300, function () {
        $('.listing-search').delay(100).animate({ width: $('.wrapp-search-right').outerWidth() }, 300, function () {
          _this.canShowBackdrop = false
          _this.searchReady = false
          $('.wrapp-ctas .wrapp-current-store').delay(100).fadeIn()
          $('.wrapp-breadcrumb').delay(100).fadeIn()
        })
      })
    },
    openScanReader () {
      const componentToLoad = import('theme/components/CodeScanner/EanScanner')
      this.$store.dispatch('ui/loadBottomActiveComponent', { component: componentToLoad })
    }
  },
  destroyed () {
    this.resetSearch()
  },
  components: {
    ProductsFiltered,
    BaseInput,
    AbsoluteLoader
  }
}
</script>
